<template>
  <div>
    <!--banner start-->

    <div class="banner-vedio">
      <figure>
        <img src="/images/vedio-banner.png" width="1400" height="530" alt="vedio-banner" />
      </figure>
      <div class="banner-vedio-cnt">
        <h1>Video Library</h1>
      </div>
    </div>

    <!--banner end-->
    <!--searchvedios block start-->
    <div class="searchvedios">
      <div class="searchvedios-main">
        <div class="searchvedios-in">
          <div class="search-input">
            <input v-model="inputSearch" placeholder="Search Videos" class="search-icon" />
          </div>
          <p class="no-videos" v-if="isEmpty(infiniteData.source)">No Videos</p>
          <infinite-container
            :handler="handleLoadmore"
            :processing="infiniteData.isProcessing"
            :is-loadmore="isLoadMore"
            :class-name="'list-card'"
          >
            <ul class="d-flex flex-wrap">
              <li
                v-for="video in infiniteData.source"
                :key="video.slug"
                class="col-12 col-sm-6 col-md-4"
              >
                <router-link :to="{ name: 'video', params: {slug: video.slug} }" class="video-item">
                  <div class="video-one">
                    <img :src="video.thumbnail" width="453" height="262" :alt="video.title" />
                    <div class="video-arrow-container">
                      <chevrons-right-icon size="3x" class="video-arrow-icon" />
                    </div>
                  </div>
                  <div class="video-des">
                    <h3>{{video.title}}</h3>
                  </div>
                </router-link>
              </li>
            </ul>
          </infinite-container>
        </div>
      </div>
    </div>
    <!--searchvedios block end-->
    <!--find block start-->

    <div class="about_main find_main">
      <div class="container">
        <div class="about about-find">
          <div class="about_hd about_hd_find">
            <h2>"Find a Counselor Near You"</h2>
          </div>
          <div class="testimonial testimonial-find">
            <div class="testimonial_in">
              <div class="test_list">
                <div class="test_cnt test_cnt_find">
                  <figure>
                    <img src="/images/img-find.png" alt="img-find" />
                  </figure>
                  <figure class="location-main">
                    <img
                      src="/images/location.png"
                      width="30"
                      height="38"
                      alt="location"
                      class="location"
                    />
                  </figure>
                  <h3>Counselor</h3>
                  <span>Duis aute irure dolor in reprehenderit</span>
                  <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia con sequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quis quam est, qui dolorem ipsum quias</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--find block end-->
  </div>
</template>

<script>
import { isEmpty, cloneDeep, size, includes, filter } from 'lodash'
import { mapState } from 'vuex'
import { ChevronsRightIcon } from 'vue-feather-icons'
import slug from '@/utils/slug'
import InfiniteContainer from '@/components/InfiniteContainer'
export default {
  name: 'VideoLibrary',
  components: {
    ChevronsRightIcon,
    InfiniteContainer
  },
  data: () => ({
    infiniteData: {
      pageSize: 12,
      currentPage: 1,
      isProcessing: false,
      number: 1,
      source: []
    },
    inputSearch: '',
    videoList: []
  }),
  computed: {
    ...mapState({
      videos: 'videos'
    }),
    isLoadMore() {
      return this.infiniteData.source.length < this.videoList.length
    }
  },
  watch: {
    videos: {
      handler(val) {
        if (!isEmpty(val)) {
          this.videoList = cloneDeep(val)
          this.handleInifiniteData()
        }
      },
      immediate: true
    },
    inputSearch(val, va2) {
      this.$set(this.infiniteData, 'currentPage', 1)
      this.videoList = filter(cloneDeep(this.videos), video => includes(slug(video.title), slug(val)))
    },
    videoList(val) {
      const pages = (size(val) / this.infiniteData.pageSize) >> 0
      const extra = size(val) % this.infiniteData.pageSize
      this.$set(this.infiniteData, 'number', extra > 0 ? pages + 1 : pages)
      this.handleInifiniteData()
    }
  },
  methods: {
    isEmpty,
    handleLoadmore(page) {
      this.$set(this.infiniteData, 'isProcessing', true)
      this.$set(this.infiniteData, 'currentPage', this.infiniteData.currentPage + 1)
      setTimeout(() => {
        this.handleInifiniteData()
        this.$set(this.infiniteData, 'isProcessing', false)
      }, 300)
    },
    handleInifiniteData() {
      this.$set(this.infiniteData, 'source', this.videoList.slice(0, this.infiniteData.currentPage * this.infiniteData.pageSize))
    }
  }
}
</script>
<style lang="scss">
.no-videos {
  color: #3e3e3e;
}
</style>
